import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";

import Grid from './Grid'
import Action from './Grid/Action'
// import Status from './Status'
import AdvancedCombobox from './AdvancedCombobox'

/**
* Class ControlledGrid
* Grid controlled by an AdvancedCombobox
**/
class ControlledGrid extends Grid {
  /**
  * props
  * title : title of the grid
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * objectClass : class name of the object's form
  * autocommit : set to true to automatically commit data on each action
  **/
  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.state = {objects: [], fields: [], status: {}};

    // Bind event functions to keep scope
    this.handleCbxChange = this.handleCbxChange.bind(this);
	}

  /**
  * componentDidMount
  * Post-rendering component function : loading data
  **/
  componentDidMount() {
    if(this.props.mode !== "add") {
      this.reload();
    }
  }

  /**
  * componentWillUnmount
  * Post-rendering component function : remove status timeout if exists
  **/
  componentWillUnmount() {
    if(this.status !== undefined) {
      this.status.unsetTimeout();
    }
  }

  /**
  * createActions
  * Creates row actions buttons
  **/
  createActions(cell, row, opt) {
    const component = <Action object={row} parentModal={this.props.parentModal} objectClass={this.props.objectClass} parentGrid={this} fields={this.state.fields} mode={this.props.mode}
      onlyDelete={(this.props.onlyDelete === false ? false : true)}></Action>;
    return component;
  }

  /**
  * render
  * Rendering component function : display the controlled grid
  **/
  render() {
    if(this.state.fields.length === 0) {
      return <div></div>;
    }
console.log('');
    // Concatenate grid headers
    let headers = this.state.fields.map(field => {
      let props = {
        key: field.nom,
        dataField: field.nom,
        isKey: field.isKey,
        ref: "table" + this.props.objectClass.getClassName() + field.nom,
        dataSort: true
      };

      if(field.filterType !== undefined) {
        props.filter = {
          type: field.filterType
        };

        if(field.filterType === "DateFilter") {
          props.dataFormat = this.dateFormatter;
          this.dateFields.push(field.nom);
        }
      }

      if(field.hidden) {
        props.hidden = true;
      }

      return <TableHeaderColumn {...props}>{field.libelle}</TableHeaderColumn>;
    });

    headers.push(<TableHeaderColumn key="actions" dataField="actions" dataFormat={this.createActions} isKey={false}></TableHeaderColumn>);

    // Form status information
    // const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const options = {
      noDataText: 'Aucune donnée à afficher'
    };

    let advancedCbx = <span />;
    if(this.props.mode === "edit" || this.props.mode === "add" || this.props.mode === undefined) {
      // Combobox props
      const advancedCbxProps = {
        ref: "advancedCbx" + this.props.objectClass.getClassName(),
        objectPath: this.props.objectPath,
        path: this.props.path + "/?interne='false'", //+ "/?interne=true"
        objectClass: this.props.objectClass,
        //url: ((this.props.mode === "add") ? REST_API_URL + this.props.path.replace("contactsEnvironnement","contacts") + "/?interne='false" : this.props.cbxUrl) + (this.props.cbxParams ? this.props.cbxParams : ""),
        url: ((this.props.mode === "add") ? REST_API_URL + this.props.path.replace("contactsEnvironnement","contacts") + "/" : this.props.cbxUrl) + (this.props.cbxParams ? this.props.cbxParams : ""),
        optionValueKey: this.props.optionValueKey,
        optionLabelKey: this.props.optionLabelKey,
        onChange: this.handleCbxChange,
        beforeAdd: this.handleCbxChange,
        enableSearch: true,
        forceSelection: true,
        disableAdd: this.props.disableAdd,
        closeOnAdd: this.props.closeModalOnAdd !== false,
        noView:true
      };

      advancedCbx = <AdvancedCombobox {...advancedCbxProps} />;
    }

    // Table props
    const tableProps = {
      ref: "table" + this.props.objectClass.getClassName(),
      maxHeight: "200px",
      data: this.state.objects,
      options: options,
      pagination: false,
      striped: true,
      bordered: false,
      hover: true
    };

    // Creating Grid
    return(
      <div className="controlledGrid">
        {advancedCbx}
        <div className="listContainer">
          <div className={"grid " + this.props.objectClass.getClassName() + "Grid"}>
            {/* {status} */}
            <BootstrapTable {...tableProps} >
              {headers}
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }

  /**
  * getAutoCommit
  * Auto commit mode or not
  **/
  getAutoCommit() {
    return this.props.autocommit === true;
  }

  /**
  * handleCbxChange
  * Handle combobox selection - add a relation between the objects
  **/
  handleCbxChange(obj, callback) {
    if(this.getAutoCommit() === true) {
      const method = "PUT";
      const idKey = this.getRowKey();
      const id = obj[idKey];
      const path = REST_API_URL + this.props.objectPath + '/' + id + "/";
      let state = this.state;
      state.objects.push(obj);

      rest({
        method: method,
        path: path,
        headers: {
    			'Content-Type': 'application/json'
    		}
      }).then(response => {
        if(response.status.code === 200 || response.status.code === 201) {
          this.setState(state);
          if(this.props.afterAdd) this.props.afterAdd.call(this, obj);
        } else {
          state.status = {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          };
          this.setState(state);
        }
    	}, response => {
        state.status = {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        };
        this.setState(state);
  		});
    } else {
      this.removeFromCombo(obj);
      this.addToGrid(obj);
      if(this.props.afterAdd) this.props.afterAdd.call(this, obj);
    }
  }

  /**
  * deleteRow
  * Handle delete action click - remove a relation between the objects
  **/
  deleteRow(object) {
    if(this.getAutoCommit() === true) {
      const idKey = this.getRowKey();
      const id = object[idKey];

      if(id === undefined || id === null) {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur : identifiant ' + this.props.objectClass + ' non défini'
          }
        });

        return;
      }

      rest({
        method: "DELETE",
        path: REST_API_URL + this.props.objectPath + '/' + id + "/"
      }).then(response => {
        if(response.status.code === 202) {
          this.setState({
            status: {
              type: 'success',
              message: 'Ligne supprimée.'
            }
          });

          this.componentDidMount();
          this.refs["advancedCbx" + this.props.objectClass.getClassName()].refresh();
        } else {
          this.setState({
            status: {
              type: 'danger',
              message: 'Erreur de sauvegarde.'
            }
          });
        }
    	}, response => {
        this.setState({
          status: {
            type: 'danger',
            message: 'Problème d\'appel au serveur.'
          }
        });
  		});
    } else {
        this.addToCombo(object);
        this.removeFromGrid(object);
    }

  }

  /**
  * addToGrid
  * Add an item to the Grid
  **/
  addToGrid(object) {
    let state = this.state;
    state.objects.push(object);

    this.setState(state);
  }

  /**
  * removeFromGrid
  * Remove an item from the Grid
  **/
  removeFromGrid(object) {
    let state = this.state;
    const idKey = this.getRowKey();

    for(let i=0; i<state.objects.length; i++) {
      const obj = state.objects[i];

      if(obj[idKey] === object[idKey]) {
        state.objects.splice(i, 1);
        break;
      }
    }

    this.setState(state);
  }

  /**
  * addToCombo
  * Add an item to the Combobox
  **/
  addToCombo(object) {
    const cbx = this.refs["advancedCbx" + this.props.objectClass.getClassName()];
    cbx.addObject(object);
  }

  /**
  * removeFromCombo
  * Remove an item from the Combobox
  **/
  removeFromCombo(object) {
    const cbx = this.refs["advancedCbx" + this.props.objectClass.getClassName()];
    cbx.removeObject(object, this.getRowKey());
  }

  /**
  * getObjectsToSave
  * Retrieve objects to save
  **/
  getObjectsToSave() {
    const idKey = this.getRowKey();
    return this.state.objects.map(object => {return object[idKey]});
  }

  /**
  * getArrayToSave
  * Retrieve objects ID to save as Array
  **/
  getArrayToSave() {
    const idKey = this.getRowKey();
    return this.state.objects.map(object => object[idKey]);
  }

  /**
  * saveAll
  * Saves the whole grid
  **/
  saveAll() {
    const method = "PUT";
    const objects = this.getObjectsToSave();
    const path = REST_API_URL + this.props.objectPath + '/';
    let state = this.state;

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(objects),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if(response.status.code === 200) {
        state.status = {
          type: 'success',
          message: 'Relations sauvegardées.'
        };
        this.setState(state);

      } else if(response.status.code === 201) {
        state.status = {
          type: 'success',
          message: 'Relations créées.'
        };
        this.setState(state);

      } else {
        state.status = {
          type: 'danger',
          message: 'Erreur de sauvegarde.'
        };
        this.setState(state);
      }
    }, response => {
      state.status = {
        type: 'danger',
        message: 'Problème d\'appel au serveur.'
      };
      this.setState(state);
    });
  }

}

export default ControlledGrid;



// WEBPACK FOOTER //
// ./src/views/Helper/ControlledGrid.js